import dashNotFourthChar from 'utils/validators/dashNotFourthChar';
import { helpers } from 'vuelidate/lib/validators';
var dashPositionError = function (param) {
    return helpers.withParams({ type: 'contains', value: param }, function (value) {
        return value.indexOf('-') === -1 ||
            (value.indexOf('-') !== -1 && !dashNotFourthChar(value));
    });
};
export default dashPositionError;
